import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { BiMap } from 'react-icons/bi';
import { v4 as uuidv4 } from 'uuid';

const WidgetGetinTouchData = [
    {
        id: uuidv4(),
        icon: <AiOutlinePhone />,
        heading: 'Phone Number',
        text: '+61 4 9716 6742',
    },

    {
        id: uuidv4(),
        icon: <AiOutlineMail />,
        heading: 'Email Address',
        text: 'info@protopath.com.au',
    },

    {
        id: uuidv4(),
        icon: <BiMap />,
        heading: 'Location',
        text: 'Australia',
    },
];

export default WidgetGetinTouchData;
